import { useLiveTimecode } from "@/hooks/useLiveTimecode";

export function Timecode() {
  const tc = useLiveTimecode();
  return (
    <span
      className="type-meta-sm"
      style={{
        color: "var(--fog)",
        opacity: 0.7,
        fontVariantNumeric: "tabular-nums",
      }}
    >
      REC [ {tc} ]
    </span>
  );
}
